import { Alert, TimePicker } from "antd";
import type { Dayjs } from "dayjs";
import dayjs from "dayjs";
import { isEmpty } from "lodash-es";
import { useCallback, useMemo } from "react";
import { useIntl } from "react-intl";
import { useUpdateListFixture } from "../../hooks";
import type { ColumnComponentProperties } from "../../types";

export const StartTimeColumn = (properties: ColumnComponentProperties) => {
  const { formatMessage } = useIntl();
  const { mutate: updateFixture, isPending } = useUpdateListFixture();

  const date = useMemo(() => properties.value?.split("T")?.[0], [properties.value]);
  const time = useMemo(() => properties.value?.split("T")?.[1]?.slice(0, 5) ?? null, [properties.value]);

  const handleChange = useCallback(
    (newTime: Dayjs) => {
      if (date) {
        let newDateTime = date;
        if (!isEmpty(newTime)) {
          newDateTime = `${newDateTime}T${dayjs(newTime).format("HH:mm:ss")}`;
        } else {
          newDateTime = `${newDateTime}T00:00:00`;
        }
        updateFixture({
          fixtureId: properties.fixtureId,
          upsertData: {
            startTimeLocal: newDateTime,
          },
        });
      }
    },
    [properties, updateFixture, date],
  );

  if (properties.editMode) {
    if (!date) {
      return (
        <Alert
          message={formatMessage({
            id: "fixtureListPage.table.column.editMode.startTime.whenNoDate",
          })}
          type={"warning"}
        />
      );
    }

    return <TimePicker disabled={isPending} format={"HH:mm"} onChange={handleChange} defaultValue={time ? dayjs(time, "HH:mm") : null} />;
  }

  return time ?? "";
};
